module.exports = __webpack_public_path__ + "img/aifxjz-main-sm.1b3a4699.jpg";